import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
  max-width: 480px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
